import { useEffect, useState } from "react";
import { useUsersAdminAction } from "../../../../services/actions/users-admin.actions";
import { useRecoilValue } from "recoil";
import { crudUsersAdminAtom } from "../../../../services/atoms/users-admin.atom";
import toast from "react-hot-toast";
import { Input, Modal, ModalBody } from "reactstrap";
import { find, map } from 'lodash';
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import { newValidatePhone } from "../../../../helpers/functions";

const initialUserData = {
  email: "",
  phone_number: "",
  name: "",
  family_name: ""
};

const getAttributes = (Attributes, key) => {
  let data = find(Attributes, (e) => e.Name === key);
  return data?.Value || ''
}

const EditUserAdminModal = (props) => {
  const { open, toggle, selectedUser, clientName} = props;
  const {
    usersAdminsList,
    updateUsersAdminsAttributes,
    resetUsersAdminCrud,
  } = useUsersAdminAction();
  const [user, setUser] = useState(initialUserData);
  const [isAdmin, setIsAdmin] = useState(true)
  const usersAdminResolver = useRecoilValue(crudUsersAdminAtom);

  useEffect(() => {
    usersAdminResolver.error &&
      toast.error("Se ha producido un error intentando actualizar al usuario");
    return () => resetUsersAdminCrud();
    //eslint-disable-next-line
  }, [usersAdminResolver.error, usersAdminResolver.message]);

  useEffect(() => {
    setUser({
      email: getAttributes(selectedUser.Attributes, 'email'),
      phone_number: getAttributes(selectedUser.Attributes, 'phone_number'),
      name: getAttributes(selectedUser.Attributes, 'name'),
      family_name: getAttributes(selectedUser.Attributes, 'family_name'),
    })
  }, [selectedUser])

  const handleChange = (key, value) =>
    setUser((prevValues) => ({ ...prevValues, [key]: value }));
  
  const handleSubmit = (e) => {
    e.preventDefault();
    let keys = [
      "name",
      "family_name",
      "email",
      "phone_number",
    ];
    let attributes = map(keys, (e) => ({
      Name: e,
    Value: user[e],
    }));
    const attributesUpdate = [...attributes, {Name:'custom:admin', Value: isAdmin.toString()}, {Name: 'custom:userBasic', Value:(!isAdmin).toString()}]
    updateUsersAdminsAttributes(user.email, attributesUpdate, () => {
      toast.success("Usuario actualizado exitosamente", {duration:4000});
      toggle("edit");
      usersAdminsList(clientName);
    });
  };
  useEffect(()=>{
    const admin = selectedUser?.Attributes.find((element)=> element.Name === 'custom:admin')
    admin?.Value === "true" ?
    setIsAdmin(true) :
    setIsAdmin(false)
  }, [])

  return(
    <Modal isOpen={open} toggle={toggle}>
      <div className='gm-modal-header'>
        <div className='gm-modal-title-container'>
          <div className='gm-modal-title'>Editar Usuario</div>
        </div>
        <button type="button" className="btn-close" aria-label="Close" onClick={toggle} />
      </div>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div className="gm-modal-form-container">
            <div className="gm-modal-form-section">
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="name">Nombre</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    placeholder="Nombre"
                    value={user?.name}
                    onChange={(e) => handleChange('name', e.target.value)}
                  />
                </div>
                <div className="gm-modal-input-group">
                  <label htmlFor="name">Apellido</label>
                  <input
                    type="text"
                    id="family_name"
                    name="family_name"
                    required
                    placeholder="Apellido"
                    value={user?.family_name}
                    onChange={(e) => handleChange('family_name', e.target.value)}
                  />
                </div>
                <div className="gm-modal-input-group">
                  <label htmlFor="userEmail">Correo</label>
                  <input
                    type="email"
                    id="userEmail"
                    name="userEmail"
                    value={user?.email || ''}
                    onChange={(e) => handleChange('email', e.target.value)}
                    maxLength={90}
                    disabled
                  />
                </div>
                <div className="gm-modal-input-group">
                  <label htmlFor="usersPhone ">Teléfono</label>
                  <Input
                    type="text"
                    id="phone_number"
                    name="phone_number"
                    value={user?.phone_number}
                    onChange={(e) => handleChange("phone_number", e.target.value)}
                    maxLength={20}
                    invalid={!newValidatePhone(user?.usersPhone)}
                    placeholder="+569 1234 5678"
                  />
                </div>
                <div className="gm-modal-input-group">
                  <label htmlFor="origenCollaborator">Rol</label>
                  <select
                    required
                    value={isAdmin}
                    onChange={()=>{setIsAdmin(!isAdmin)}}
                  >
                    <option value={true}>Administrador Empresa</option>
                    <option value={false}>Analista</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="gm-modal-buttons">
            <button
              type="button"
              className="gm-secondary-button"
              onClick={toggle}
            >
              Cancelar
            </button>
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel="Guardar"
              disabled={
                user?.usersPhone === "" ||
                !newValidatePhone(user?.usersPhone)
              }
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
};
export default EditUserAdminModal;
